export const isReactNative = () => {
    return typeof window.ReactNativeWebView !== 'undefined';
}

export const postToRNVebView = (type, jsonData) => {
    if (isReactNative()) {
        // sending post message to the react native webview
        window.ReactNativeWebView.postMessage(JSON.stringify({
            ...jsonData,
            ...{type: type}
        }));
    }
}
